/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Product } from './Product';
import {
    ProductFromJSON,
    ProductFromJSONTyped,
    ProductToJSON,
} from './Product';

/**
 * Representation of a Product Reference
 * @export
 * @interface ProductReference
 */
export interface ProductReference {
    /**
     * Reference type
     * @type {string}
     * @memberof ProductReference
     */
    referenceType?: string;
    /**
     * Reference description
     * @type {string}
     * @memberof ProductReference
     */
    description?: string;
    /**
     * Reference quantity
     * @type {number}
     * @memberof ProductReference
     */
    quantity?: number;
    /**
     * 
     * @type {Product}
     * @memberof ProductReference
     */
    target?: Product;
    /**
     * Flag stating if product reference is preselected
     * @type {boolean}
     * @memberof ProductReference
     */
    preselected?: boolean;
}

/**
 * Check if a given object implements the ProductReference interface.
 */
export function instanceOfProductReference(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ProductReferenceFromJSON(json: any): ProductReference {
    return ProductReferenceFromJSONTyped(json, false);
}

export function ProductReferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductReference {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'referenceType': !exists(json, 'referenceType') ? undefined : json['referenceType'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'quantity': !exists(json, 'quantity') ? undefined : json['quantity'],
        'target': !exists(json, 'target') ? undefined : ProductFromJSON(json['target']),
        'preselected': !exists(json, 'preselected') ? undefined : json['preselected'],
    };
}

export function ProductReferenceToJSON(value?: ProductReference | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'referenceType': value.referenceType,
        'description': value.description,
        'quantity': value.quantity,
        'target': ProductToJSON(value.target),
        'preselected': value.preselected,
    };
}

